import { hotProducts } from "@/mocks/home";

const productImages: Record<string, string> = {
  "prod-nike-dunk": "https://readdy.ai/api/search-image?query=A%20pair%20of%20grey%20and%20white%20Nike%20Dunk%20Low%20sneakers%20on%20a%20warm%20amber%20terrazzo%20floor%2C%20dramatic%20diagonal%20sunlight%20casting%20sharp%20shadows%2C%20urban%20lifestyle%20product%20photography%20with%20high%20contrast%20and%20editorial%20streetwear%20feel&width=500&height=500&seq=prod-dunk-v02&orientation=squarish",
  "prod-jordan-4": "https://readdy.ai/api/search-image?query=Black%20and%20red%20Jordan%204%20Retro%20sneakers%20on%20a%20dark%20charcoal%20concrete%20surface%20with%20red%20accent%20lighting%20reflecting%20underneath%2C%20edgy%20dramatic%20product%20photography%20with%20bold%20color%20contrast%20and%20premium%20athletic%20aesthetic&width=500&height=500&seq=prod-jordan4-v02&orientation=squarish",
  "prod-trapstar": "https://readdy.ai/api/search-image?query=A%20black%20Trapstar%20hoodie%20draped%20on%20a%20metal%20locker%20room%20bench%20with%20moody%20overhead%20fluorescent%20lighting%2C%20urban%20street%20photography%20style%20with%20gritty%20authentic%20atmosphere%20and%20dark%20shadowy%20tones&width=500&height=500&seq=prod-trapstar-v02&orientation=squarish",
  "prod-stussy": "https://readdy.ai/api/search-image?query=A%20white%20Stussy%20logo%20t-shirt%20hanging%20on%20a%20wire%20hanger%20against%20a%20sun%20bleached%20pastel%20yellow%20wall%2C%20California%20summer%20afternoon%20light%2C%20relaxed%20surf%20street%20lifestyle%20photography%20with%20warm%20nostalgic%20vibes&width=500&height=500&seq=prod-stussy-v02&orientation=squarish",
  "prod-corteiz": "https://readdy.ai/api/search-image?query=Olive%20green%20cargo%20pants%20laid%20on%20a%20rough%20asphalt%20surface%20with%20painted%20yellow%20road%20markings%2C%20gritty%20urban%20outdoor%20photography%20with%20industrial%20raw%20aesthetic%20and%20streetwear%20edge&width=500&height=500&seq=prod-corteiz-v02&orientation=squarish",
  "prod-essentials": "https://readdy.ai/api/search-image?query=A%20beige%20Essentials%20hoodie%20folded%20on%20a%20warm%20sand%20colored%20linen%20bed%20with%20soft%20diffused%20morning%20window%20light%2C%20calm%20minimalist%20lifestyle%20photography%20with%20serene%20neutral%20tones%20and%20comfortable%20luxury%20feel&width=500&height=500&seq=prod-essentials-v02&orientation=squarish",
};

export default function Products() {
  return (
    <section className="py-16 md:py-20 px-4 md:px-8 lg:px-14 bg-secondary-50/60">
      <div className="max-w-[1400px] mx-auto">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between mb-10 gap-4">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
              Os Produtos Mais <span className="text-primary-600">Procurados</span>
            </h2>
            <p className="text-sm md:text-base text-foreground-500 mt-2">
              Mais vendidos do CSSBuy Spreadsheet esta semana
            </p>
          </div>
          <span className="inline-flex items-center gap-1.5 px-4 py-2 text-xs font-semibold text-primary-700 bg-primary-50 rounded-full whitespace-nowrap">
            <i className="ri-global-line"></i>
            Frete internacional
          </span>
        </div>

        <div className="flex gap-5 overflow-x-auto pb-4 scrollbar-hide" style={{ scrollSnapType: "x mandatory" }}>
          {hotProducts.map((product) => (
            <a
              key={product.name}
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="flex-shrink-0 w-[260px] md:w-[280px] bg-background-50 rounded-2xl overflow-hidden cursor-pointer group"
              style={{ scrollSnapAlign: "start" }}
            >
              <div className="relative h-60 md:h-64 overflow-hidden">
                <img
                  src={productImages[product.imageSeq] || productImages["prod-nike-dunk"]}
                  alt={product.name}
                  title={`${product.name} - CSSBuy Spreadsheet`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-4">
                <p className="text-xs text-foreground-500 mb-1">{product.category}</p>
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 leading-snug whitespace-nowrap overflow-hidden text-ellipsis">
                  {product.name}
                </h3>
                <div className="flex items-center justify-between mt-3">
                  <span className="text-lg font-bold text-primary-600">{product.price}</span>
                  <span className="text-xs text-foreground-400 flex items-center gap-1">
                    <i className="ri-verified-badge-line text-primary-500"></i>
                    Verificado
                  </span>
                </div>
              </div>
            </a>
          ))}
        </div>

        <div className="flex justify-center mt-8">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-7 py-3 text-sm font-semibold text-background-50 bg-primary-500 hover:bg-primary-600 rounded-full transition-colors cursor-pointer whitespace-nowrap"
          >
            Abrir Spreadsheet
            <i className="ri-arrow-right-up-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}